import { Form, Input, Select, Table } from "antd";
import FormBox from "../../Atoms/FormBox/FormBox";
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Modal from "../Modal/Modal";
import { useModal } from '../../../customHooks/useModal'
import iconWarning from '../../../assets/warning.svg'
import Button from "../../Atoms/Button/Button";
import iconSuccess from '../../../assets/iconProfileCreate.svg'
import { useLocation } from "wouter";

const columns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Rol",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
  },
];

const FormProfileEdit = () => {
  const [isOpenModalDeleteSuccess, openModalDeleteSuccess, closeModalDeleteSuccess] = useModal(false)
  const [isOpenModalDelete, openModalDelete, closeModalDelete] = useModal(false)
  const [isOpenModalSuccess, openModalSuccess, closeModalSuccess] = useModal(false)
  const [form] = Form.useForm();
  const [, setLocation] = useLocation();

  // Funcion para eliminar campaña
  const deleteCampains = () => {
    closeModalDelete()
    openModalDeleteSuccess()
  }

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModalSuccess(true) // Si se envia el formulario correctamente, se muestra el modal
  };

  const deleteProfile = () => {
    openModalDelete()
    return
  }

  const usersList = [
    {
      key: 1,
      name: 'Nombre de la campaña creada, si tiene dos',
      role: 'Administrativo.',
      actions:  <span className="button outline small primary source-16 s-large m-auto">Eliminar</span>
    },
    {
      key: 2,
      name: 'Nombre de la campaña creada, si tiene dos',
      role: 'Funcional.',
      actions:  <span className="button outline small primary source-16 s-large m-auto">Eliminar</span>
    },
    {
      key: 3,
      name: 'Nombre de la campaña creada, si tiene dos',
      role: 'Agente.',
      actions:  <span className="button outline small primary source-16 s-large m-auto">Eliminar</span>
    },
  ]
  
  return (
    <>
    <Form onFinish={sendForm} form={form} initialValues={
      {
        nombre: 'Nombre usuario', 
        apellido: 'Apellido usuario',
        email: 'email@user',
        movil: '04movil',
        type: ['Administrativo', 'Agente' ]
      }
    }>
      <FormBox>
        <FormTitle text="Datos del perfil de usuario" />

        <InputFormContainer label="Nombre:" indentificador="nombre">
          <Form.Item
            name="nombre"
            rules={[{ required: true, message: "Por favor ingresa tu nombre" }]}
          >
            <Input size="large" placeholder="José Alejandro" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Apellido:" indentificador="apellido">
          <Form.Item
            name="apellido"
            rules={[
              { required: true, message: "Por favor ingresa tu apellido" },
            ]}
          >
            <Input size="large" placeholder="Gonzáles" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Email personal:" indentificador="email">
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Por favor ingresa tu email" }]}
          >
            <Input size="large" placeholder="José Alejandro" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Móvil:" indentificador="movil">
          <Form.Item
            name="movil"
            rules={[{ required: true, message: "Por favor ingresa tu movil" }]}
          >
            <Input size="large" placeholder="José Alejandro" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer spanTwo label="Tipo de rol (puedes asignar más de uno):" indentificador="type">
          <Form.Item
            name="type"
            rules={[{ required: true, message: "Por favor ingrese Tipo de rol" }]}
          >
            <Select placeholder="Tipo de rol" mode="multiple" size="large">
              <Select.Option value="Administrativo" key={1}>
                Administrativo
              </Select.Option>
              <Select.Option value="Funcional" key={2}>
                Funcional
              </Select.Option>
              <Select.Option value="Agente" key={3}>
                Agente
              </Select.Option>
            </Select>
          </Form.Item>
        </InputFormContainer>
        
        <p className="mb-30 source-10 m-cols-2">Campañar asignadas a este perfil:</p>
        
        <div className="m-cols-2">
          <div className="table-container">
            <Table
              columns={columns}
              dataSource={usersList}
              pagination={false}
            />
          </div>
          <div className="buttons-container mt-30">
            <span className="button primary source-16 outline s-large m-auto" onClick={() => deleteProfile()}>Suspender</span>
            <Button content="Actualizar Información" customClass="s-large m-auto" type="primary" />
          </div>
        </div>
       
        <div className="m-cols-2">
          <h3 className="source-24 mt-20 mb-20">Datos del perfil de usuario</h3>
          <div className="buttons-container start">
            <span className="button third source-16 m-auto" onClick={() => deleteProfile()}>Eliminar perfil</span>
          </div>
         
        </div>
        
      </FormBox>
    </Form>

    {/* Modal la editar informacion correctamente */}
    <Modal
        isOpenModal={isOpenModalSuccess}
        closeModal={closeModalSuccess}
        iconModal={iconSuccess}
        titleModal="¡Listo!" 
        subTitleModal="Haz actualizado del perfil correctamente ¿Qué quieres hacer ahora?"
      >
       <div className="buttons-container center">
          <Button content="Crear una campana" customClass="s-large m-auto" type="primary" clickHandler={() => setLocation('/campaigns/gestionar')} />
          <Button content="Gestionar Roles" customClass="s-large m-auto" type="primary outline" clickHandler={() => setLocation('/perfiles-roles/gestionar')} />
       </div>
      </Modal> 

    {/* Modal al tratar eliminar una campaña asignada */}
    <Modal
        isOpenModal={isOpenModalDelete}
        closeModal={closeModalDelete}
        iconModal={iconWarning}
        titleModal="¡Cuidado!" 
        subTitleModal="Estas a punto de eliminar o suspender un perfil, ¿confirmas esta acción?"
      >
       <div className="buttons-container center">
          <Button content="Si, eliminar o suspender" customClass="s-large m-auto" type="primary" clickHandler={deleteCampains}/>
          <Button content="Cancelar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalDelete()}/>
       </div>
      </Modal> 

    {/* Modal al eliminar una campaña asignada */}
    <Modal
        isOpenModal={isOpenModalDeleteSuccess}
        closeModal={closeModalDeleteSuccess}
        iconModal={iconWarning}
        titleModal="Revisa tu correo" 
        subTitleModal="Un correo llegará a tu bandeja, debes confirmarlo para confirmar la eliminación del perfil."
      >
       <div className="buttons-container center">
        <Button content="Aceptar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalDeleteSuccess()}/>
       </div>
      </Modal> 
    </>
  );
};

export default FormProfileEdit;
